import httpClient from "@utils/httpClient";

/**
 * Full daily-plan gate state (working day? window open? plan/EOD submitted?
 * pending retro-EOD? carry-over tasks? today's tasks? gateRequired).
 */
export const getDayState = async () => {
  try {
    const response = await httpClient.get('/employee/daily-plan/day-state');
    return {
      success: response.success,
      data: response.data || null,
      error: response.error
    };
  } catch (error) {
    console.error('getDayState error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

/**
 * Submit the Plan for the Day = indirect punch-in.
 * @param {{tasks: Array, carryOver: Array, remarks?: string}} payload
 */
export const submitPlan = async (payload) => {
  try {
    const response = await httpClient.post('/employee/daily-plan/submit-plan', payload);
    return {
      success: response.success,
      data: response.data || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('submitPlan error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to submit plan' }
    };
  }
};

/**
 * Submit the EOD report = punch-out (today or retroactive prior day).
 * @param {{forDate?: string, taskStatuses: Array, remarks?: string}} payload
 */
export const submitEod = async (payload) => {
  try {
    const response = await httpClient.post('/employee/daily-plan/submit-eod', payload);
    return {
      success: response.success,
      data: response.data || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('submitEod error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to submit end-of-day report' }
    };
  }
};

/**
 * Previous working day's not-completed tasks (carry-over candidates).
 */
export const getCarryOver = async () => {
  try {
    const response = await httpClient.get('/employee/daily-plan/carry-over');
    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getCarryOver error:', error);
    return { success: false, data: [], error: { message: error.message } };
  }
};
